import React from 'react';
import { fromPairs, map } from 'lodash';

// local Dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';

/**
 * @type { object }
 * @desc A React presentation/dumb view component.
 * @example
 * import { captureReasonCancelOrder as CaptureReasonCancelOrder } from 'ui/views/widgets/captureReasonCancelOrder';
 *
 * // render
 * <CaptureReasonCancelOrder propName='propValue'/>
 */
export const captureReasonCancelOrder = ( props ) => {
	const fieldsData = props.widgetConfig.fields;

	return (
		<div className='ui-capture-reason-cancel-order'>
			<div className='ui-capture-reason-cancel-order__header'>
				{ /* title for the modal */ }
				<div className='ui-capture-reason-cancel-order__header__title'>
					{ getLabel( props.title ) }
				</div>

				{ /* close button */ }
				<div
					className='ui-error-overlay__head__close'
					onClick={ () => props.closeOverlay() }
				>
					<Icon name='close' width='14' height='14' fill='#ffffff' />
				</div>
			</div>
			<div className='ui-capture-reason-cancel-order__body'>
                <div className='ui-capture-reason-cancel-order__body__description'>
                    <div className='ui-capture-reason-cancel-order__body__description__icon'>
                        <Icon name='danger' width='36' height='36'/>
                    </div>
                    { /* title for the modal */ }
                    <div className='ui-capture-reason-cancel-order__body__description__title'>
                        { getLabel( props.confirmation ) }
                    </div>
                </div>

				<Form
					fields={ fromPairs( map( fieldsData, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
					values={ {} } // default values
					isValid={ false }
					mode={ props.mode }
					onSubmit={ ( { values, isValid } ) => {
						isValid ? props.onSumbitClick( values.cancellationReason ) : null;
					} }
				>
					{ ( { fields, values, /* isValid */ errors, onChange, onSumbit } = {} ) => {
						return (
							<form
								onSubmit={ onSumbit }
								className='ui-capture-reason-cancel-order__body__form'
							>
								{ /* fields */ }
								{ map( fields, ( field ) => {
									return (
										<field.view
											key={ field.name }
											className='ui-capture-reason-cancel-order__body__form__field'
											name={ field.name }
											required={ field.required }
											placeholder={ field.placeholder }
											label={ field.title }
											onChange={ onChange }
											value={ values[ field.name ] }
											error={ errors[ field.name ] }
											mode={ props.mode }
											maxLength={ field.maxLength }
										/>
									);
								} ) }

                                <div className='ui-capture-reason-cancel-order__body__form__actions' >
                                    { map( props.widgetConfig.actions, ( action ) => {
                                        return (
                                            <Button
                                                id={ action.name }
                                                key={ action.name }
                                                size='large'
                                                outline={ 'cancel' === action.name ? true : false }
                                                type={ 'cancel' === action.name ? 'button' : 'submit' }
                                                title={ action.title }
                                                className='ui-capture-reason-cancel-order__body__form__actions__action'
                                                onClick={
                                                    'cancel' === action.name
                                                        ? () => props.closeOverlay()
                                                        : null
                                                }
                                            />
                                        );
                                    } ) }
                                </div>
							</form>
						);
					} }
				</Form>
			</div>
		</div>
	);
 };

// set display name
captureReasonCancelOrder.displayName = 'captureReasonCancelOrder';

// set default props
captureReasonCancelOrder.defaultProps = {};

// prop types
captureReasonCancelOrder.propTypes = {};
